<template>
  <v-dialog :model-value="modelValue" @update:modelValue="$emit('update:modelValue', $event)" width="500px">
    <v-card>
      <v-card-title>{{ isCreate ? "Create Product" : "Edit Product" }}</v-card-title>
      <v-card-content>
        <v-container>
          <v-form ref="form">
            <v-text-field
              v-model="localData.itemToEdit.name"
              label="Name"
              :rules="mandatoryRule"
              required
            />
            <v-autocomplete
              v-model="localData.itemToEdit.unitId"
              :items="localData.unitsOfMeasure"
              item-title="name"
              item-value="id"
              label="Unit Of Measure"
              :rules="mandatoryRule"
              required
            />
            <v-row no-gutters align="center">
              <v-col cols="10">
                <v-text-field
                  v-model="localData.itemToEdit.barcode"
                  label="Barcode"
                  :rules="mandatoryRule"
                  required
                />
              </v-col>
              <v-col cols="2">
                <v-btn icon="mdi-barcode-scan" @click="toggleCamera" />
              </v-col>
            </v-row>
            <v-row justify="center" align="center" class="mt-n2">
              <v-col v-if="scanActive" class="d-flex justify-center align-center">
                <BarcodeScanner @detect="onDetect" @error="onError" />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-content>
      <v-card-actions class="justify-space-between">
        <v-btn color="primary" @click="closeDialog">Cancel</v-btn>
        <div>
          <v-btn v-if="!isCreate" color="error" @click="deleteProduct">Delete</v-btn>
          <v-btn color="primary" @click="saveChanges">{{ isCreate ? "Create" : "Save" }}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, defineProps, defineEmits, reactive, watch } from 'vue';
import BarcodeScanner from "@/components/BarcodeScanner.vue";

const props = defineProps({
  modelValue: Boolean,
  dialogData: Object
})

const emit = defineEmits(['update:modelValue','close', 'save']);

const localData = reactive({
      itemToEdit: {
        name:'',
        unitId:null,
        barcode:''
      },
      unitsOfMeasure: [],
      isCreate:'',
})

// Synchroniser les données locales avec les props
watch(() => props.dialogData, (newData) => {
  Object.assign(localData, newData);
}, { immediate: true, deep: true });

    const mandatoryRule = [(v) => !!v || "Mandatory field"];
    const scanActive = ref(false);

    // Toggle pour scanner
    const toggleCamera = () => {
      scanActive.value = !scanActive.value;
    };

    // Sauvegarde de l'élément
    const saveChanges = async () => {
        emit("save", {...localData.itemToEdit}, localData.isCreate);
    };

    // Suppression de l'élément
    const deleteProduct = () => {
      emit("delete", props.dialogData.itemToEdit);
    };

    const closeDialog = () => {
      emit('close');
    }

    // Gestion de la détection du code-barres
    const onDetect = (code) => {
      localData.itemToEdit.barcode = code;
      scanActive.value = false;
    };

    // Gestion des erreurs de scan
    const onError = (error) => {
      console.error(error);
    };
</script>